type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const OBSERVATORY_PAGES: ImpactModulePages = {
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupos',
    description: 'Gestão das permissões dos grupo',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões dos agentes',
    description: 'Gestão das permissões dos agentes públicos',
  },
  //REPORTS
  UNIFIED_PERSON_ATTENDANCE: {
    name: 'População: População atendida',
    description: '',
  },
  UNIFIED_PERSON_RESIDENCE: {
    name: 'População: População residente',
    description: '',
  },
  ORIGIN_PERSON_ORIGIN: {
    name: 'População: Cadastro na base',
    description: '',
  },
  ORIGIN_PERSON_DATA_HYGIENE: {
    name: 'População: Higienização dos dados',
    description: '',
  },
  ORIGIN_ACTIVITY_PRIMARY_CARE: {
    name: 'Atividades: Atenção básica',
    description: '',
  },
  ORIGIN_ACTIVITY_ATTENDANCE: {
    name: 'Atividades: Atendimentos',
    description: '',
  },
  ORIGIN_ACTIVITY_ACTIVITY_TYPE: {
    name: 'Atividades: Atividades por tipo',
    description: '',
  },
  ORIGIN_ACTIVITY_REVIEW: {
    name: 'Atividades: Avaliações',
    description: '',
  },
  ORIGIN_ACTIVITY_CID: {
    name: 'Atividades: CIDs',
    description: '',
  },
  ORIGIN_ACTIVITY_EXECUTION: {
    name: 'Atividades: Metas e execução',
    description: '',
  },
  ORIGIN_ACTIVITY_VACCINE: {
    name: 'Atividades: Vacinas',
    description: '',
  },
  PLACE_FLOW: {
    name: 'Unidades: Fluxo',
    description: '',
  },
  ALERT: {
    name: 'Casos e Alertas: Visão dos casos',
    description: '',
  },
}
